<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">
    <span style="width: 100%; display: inline-flex; justify-content: space-between; align-items: center">
        <span> {{ this.get?.webpage_heading }} </span>
        <button style="background: transparent; border: none; margin: none; outline: none; padding: none; color: white" (click)="dialogRef.close()"><span class="far fa-times"></span></button>
    </span>
</h2>
<mat-dialog-content>
    <ng-container *ngIf="!!get">
        <tt-input-number ttLabel="freight_eu" [(ttModel)]="get.freight_eu" ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="freight_ex_eu" [(ttModel)]="get.freight_ex_eu" ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="customs_eu" [(ttModel)]="get.customs_eu" ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="customs_ex_eu" [(ttModel)]="get.customs_ex_eu" ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="divcost" [(ttModel)]="get.divcost" ttDecimals="2"></tt-input-number>
        <ng-container *ngIf="get.show_stocklocation_keyno === '1'">
            <tt-input ttLabel="stockplace_name" [ttModel]="get.stockplace_name" ttReadonly></tt-input>
            <tt-select ttLabel="stocklocation" [(ttModel)]="get.stocklocation_keyno" [ttData]="stocklocations" ttDataName="stocklocation_name" ttDataId="stocklocation_keyno"></tt-select>
        </ng-container>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <tt-button-save ttText="purchhead_receive_simplified_create" (ttClick)="create()" [ttLoading]="creating"></tt-button-save>
</mat-dialog-actions>
